// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"6e7a7f0a","453":"45d86ab6","464":"d0674b24","765":"308703b2","883":"2b0f7c5b"}[chunkId] + ".chunk.js";
};